import { required, maxLength } from 'vuelidate/lib/validators'
import { validateRegexData, validateRegexComputed } from './validateRegex'

export const validateData = {
  form: {
    ...validateRegexData,
    acao: {
      description: { required, maxLength: maxLength(35) },
      centroDeCusto: { required },
      ura_id: { required },
    },
  },
}

export const validateComputed = {
  ...validateRegexComputed,
  descriptionErrors() {
    const errors = []
    if (!this.$v.form.acao.description.$dirty) return errors
    !this.$v.form.acao.description.required && errors.push('Descrição é obrigatória.')
    !this.$v.form.acao.description.maxLength && errors.push('Máximo 35 caracteres.')
    return errors
  },
  centroDeCustoErrors() {
    const errors = []
    if (!this.$v.form.acao.centroDeCusto.$dirty) return errors
    !this.$v.form.acao.centroDeCusto.required && errors.push('Centro de custo é obrigatório.')
    return errors
  },
  uraErrors() {
    const errors = []
    if (!this.$v.form.acao.ura_id.$dirty) return errors
    !this.$v.form.acao.ura_id.required && errors.push('URA é obrigatória.')
    return errors
  },
}
